export default {"src":"/_next/static/media/0x3aab2285ddcddad8edf438c1bab47e1a9d05a9b4.684ff353.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};